import React, { useState, useEffect, useRef } from "react";
import "../../components/Login/Login.scss";
import { useDispatch } from "react-redux";
import { loginReducer } from "../../Redux/store";
import { ReactComponent as CMSLOGO } from "../../images/CMS_UMS_LOGO.svg";
import { Route, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TextField from "@mui/material/TextField";
import { InputAdornment, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import "./ResetPswrd.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ResetPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNoMatchError, setNoMatchError] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const [error, setError] = useState("");
  const [EnterdValue, setValue] = useState(false);
  const [buttonclicked, setButtonclicked] = useState(false);
  const [validPassword, setValidPassword] = useState(false);

  // Password criteria states
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [hasMinLength, setHasMinLength] = useState(false);

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    retry_password: "",
  });

  // Check if all password criteria are met
  const isPasswordValid = hasUpperCase && hasLowerCase && hasSpecialChar && hasMinLength;

  const validatePassword = (password) => {
    // Check for uppercase letters
    const upperCaseRegex = /[A-Z]/;
    setHasUpperCase(upperCaseRegex.test(password));

    // Check for lowercase letters
    const lowerCaseRegex = /[a-z]/;
    setHasLowerCase(lowerCaseRegex.test(password));

    // Check for special characters
    const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    setHasSpecialChar(specialCharRegex.test(password));

    // Check for minimum length (8 characters)
    setHasMinLength(password.length >= 8);

    // Set overall password validity
    const isValid = upperCaseRegex.test(password) && 
                    lowerCaseRegex.test(password) && 
                    specialCharRegex.test(password) && 
                    password.length >= 8;
    
    setValidPassword(isValid);
  };

  const handButtonclick = () => {
    setButtonclicked(true);
  };

  const ClearInputfiled = () => {
    setShowOldPassword("");
    setShowNewPassword("");
    setShowRetypePassword("");
    setFormData({ old_password: "", new_password: "", retry_password: "" });
    setHasUpperCase(false);
    setHasLowerCase(false);
    setHasSpecialChar(false);
    setHasMinLength(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("formDatasfsdf", formData);

    if (!validPassword) {
      toast.error("Please correct the password format", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    if (formData.new_password === formData.retry_password) {
      let data = {
        oldpassword: formData.old_password,
        password: formData.new_password,
      };
      setNoMatchError(false);
      try {
        const resp = await axios.put(
          "auth/resetpassword/" +
            JSON.parse(sessionStorage.getItem("userdata")).te_userid,
          data,
          {
            headers: {
              Authorization:
                "Bearer" + " " + sessionStorage.getItem("access_token"),
            },
          }
        );
        
        if (resp.status === 200) {
          sessionStorage.clear();
          navigate("/login");
        }
      } catch (err) {
        if(err.response.data.message==="Incorrect old password"){
          toast.error("Old password is invalid", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        else if(err.response){
          toast.error(err.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      }
    } else {
      setNoMatchError(true);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    if (e.target.name === "new_password") {
      validatePassword(e.target.value);
    }
  };

  const handleClickShowPassword = () => {
    setShowOldPassword(!showOldPassword);
  };

  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleClickShowRetypePassword = () => {
    setShowRetypePassword(!showRetypePassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Styling for password criteria indicators
  const criteriaStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
    fontSize: "12px",
  };

  const validStyle = {
    color: "#4CAF50",
  };

  const invalidStyle = {
    color: "#F44336",
  };

  const iconStyle = {
    fontSize: "14px",
    marginRight: "5px",
  };

  return (
    <div className="login-page">
      <ToastContainer />
      <div className="forgotpass-page" style={{ overflow: "hidden" }}>
        <div className="row">
          <CMSLOGO
            style={{
              width: "30px",
              height: "auto",
              position: "absolute",
              top: "40px",
              left: "60px",
            }}
          />
        </div>

        <div className="row ">
          <div className="col-lg-6 col-md-6  col-sm-12 col-one">
            <div style={{ marginTop: "11%", marginLeft: "70px" }}>
              <form onSubmit={handleSubmit}>
                <div className="forget-text">Reset Password </div>

                <Box
                  sx={{
                    "& > :not(style)": { width: "459px" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <div className="username-field">Old Password</div>
                  <TextField
                    id="UserName"
                    placeholder="Old Password"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    name="old_password"
                    value={formData.old_password}
                    onChange={handleChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        background: "#1A1A1A",
                        border: "1px solid #262626",
                        borderRadius: "10px",
                        marginBottom: "10px",
                      },
                      "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover": {
                        "& > fieldset": {
                          borderColor: "#262626",
                          border: "1px solid",
                          borderRadius: "5px",
                        },
                      },
                    }}
                    type={showOldPassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            style={{ color: "#FFFFFF" }}
                          >
                            {showOldPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: {
                        height: "47px",
                        color: "#FFFFFF",
                      },
                    }}
                  />

                  {formData.old_password == "" && buttonclicked && (
                    <p className="warning-messages">
                      Please enter your old password.
                    </p>
                  )}

                  <div className="username-field">New Password</div>
                  <TextField
                    id="UserName"
                    placeholder="New Password"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    name="new_password"
                    value={formData.new_password}
                    onChange={handleChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        background: "#1A1A1A",
                        border: "1px solid #262626",
                        borderRadius: "10px",
                        marginBottom: "10px",
                      },
                      "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover": {
                        "& > fieldset": {
                          borderColor: "#262626",
                          border: "1px solid",
                          borderRadius: "5px",
                        },
                      },
                    }}
                    type={showNewPassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowNewPassword}
                            onMouseDown={handleMouseDownPassword}
                            style={{ color: "#FFFFFF" }}
                          >
                            {showNewPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: {
                        height: "47px",
                        color: "#FFFFFF",
                      },
                    }}
                  />

                  {/* Password criteria indicators */}
                  <div className="password-criteria-container" style={{ marginBottom: "15px" }}>
                    <div style={{ ...criteriaStyle, ...(hasUpperCase ? validStyle : invalidStyle) }}>
                      {hasUpperCase ? 
                        <CheckCircleIcon style={iconStyle} /> : 
                        <CancelIcon style={iconStyle} />}
                      At least one uppercase letter
                    </div>
                    <div style={{ ...criteriaStyle, ...(hasLowerCase ? validStyle : invalidStyle) }}>
                      {hasLowerCase ? 
                        <CheckCircleIcon style={iconStyle} /> : 
                        <CancelIcon style={iconStyle} />}
                      At least one lowercase letter
                    </div>
                    <div style={{ ...criteriaStyle, ...(hasSpecialChar ? validStyle : invalidStyle) }}>
                      {hasSpecialChar ? 
                        <CheckCircleIcon style={iconStyle} /> : 
                        <CancelIcon style={iconStyle} />}
                      At least one special character
                    </div>
                    <div style={{ ...criteriaStyle, ...(hasMinLength ? validStyle : invalidStyle) }}>
                      {hasMinLength ? 
                        <CheckCircleIcon style={iconStyle} /> : 
                        <CancelIcon style={iconStyle} />}
                     Minimum of 8 characters in length
                    </div>
                  </div>

                  {formData.new_password == "" && buttonclicked && (
                    <p className="warning-messages">
                      Please enter new password.
                    </p>
                  )}

                  <div className="username-field">Confirm Password</div>
                  <TextField
                    id="UserName"
                    placeholder="Confirm Password"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    name="retry_password"
                    value={formData.retry_password}
                    onChange={handleChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        background: "#1A1A1A",
                        border: "1px solid #262626",
                        borderRadius: "10px",
                        marginBottom: "10px",
                      },
                      "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover": {
                        "& > fieldset": {
                          borderColor: "#262626",
                          border: "1px solid",
                          borderRadius: "5px",
                        },
                      },
                    }}
                    type={showRetypePassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowRetypePassword}
                            onMouseDown={handleMouseDownPassword}
                            style={{ color: "#FFFFFF" }}
                          >
                            {showRetypePassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: {
                        height: "47px",
                        color: "#FFFFFF",
                      },
                    }}
                  />

                  {formData.retry_password == "" && buttonclicked && (
                    <p className="warning-messages">
                      Please enter retry password.
                    </p>
                  )}
                </Box>
                {showNoMatchError == true && (
                  <p className="warning-messages">Password MisMatch</p>
                )}

                <div style={{ display: "flex" }}>
                  <div className="submit-cancel">
                    <button
                      className="generatepassword"
                      type="submit"
                      onClick={handButtonclick}
                      disabled={!isPasswordValid}
                      style={{
                        opacity: isPasswordValid ? 1 : 0.5,
                        cursor: isPasswordValid ? "pointer" : "not-allowed"
                      }}
                    >
                      Reset Password
                    </button>
                  </div>

                  <div className="back-login">
                    <button
                      className="CenclBtn"
                      type="button"
                      onClick={ClearInputfiled}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <br></br>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;